import { api } from "../api"

export const propertyViewApi = (data) => { 
    return api.post("/api/admin/view-property",JSON.stringify(data))
 }
export const propertyUpdateApi = (data) => { 
    console.log(data,"qqqq");
    return api.post("/api/admin/properties/approve-reject",JSON.stringify(data))
 }